module.exports = __webpack_public_path__ + "static/img/logo.0d96c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/logo.png
// module id = w2uv
// module chunks = 1